import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
// Add your imports here
import PetProfilePage from "./pages/PetProfile";
import Login from "pages/login";
import ProductListing from "pages/product-listing";
import ProductDetail from "pages/product-detail";
import ShoppingCart from "pages/shopping-cart";
import Register from "pages/register";
import OrderConfirmation from "pages/order-confirmation";
import UserAccountDashboard from "pages/user-account-dashboard";
import OrderHistory from "pages/order-history";
import Checkout from "pages/checkout";
import NotFound from "pages/NotFound";
import EditProfile from "pages/edit-profile";
import Wishlist from "pages/wishlist";
import AboutUs from "pages/about-us";
import ArabicPharmacyEcommerceLandingPage from "pages/arabic-pharmacy-e-commerce-landing-page";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          <Route path="/" element={<ArabicPharmacyEcommerceLandingPage />} />
          <Route path="/pet-profile" element={<PetProfilePage />} />
          {/* <Route path="/" element={<HomePage />} />*/}
   
            <Route path="/about-us" element={<AboutUs />} />
          <Route path="/login" element={<Login />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/product-listing" element={<ProductListing />} />
          <Route path="/product-detail" element={<ProductDetail />} />
          <Route path="/shopping-cart" element={<ShoppingCart />} />
          <Route path="/register" element={<Register />} />
          <Route path="/order-confirmation" element={<OrderConfirmation />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route path="/wishlist" element={<Wishlist />} />
          <Route
            path="/user-account-dashboard"
            element={<UserAccountDashboard />}
          />
          <Route path="/order-history" element={<OrderHistory />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
